// Media Session API — makes headphone buttons work.
// Requires a real <audio> element to be playing, otherwise the browser
// won't register the action handlers. We play a silent loop for this.

// Minimal valid WAV: 44-byte header + 0 bytes of audio data.
const SILENT_WAV =
  'data:audio/wav;base64,' +
  'UklGRiQAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAAABkYXRhAAAAAA=='

let silenceEl = null

export function init(dispatch) {
  if (!('mediaSession' in navigator)) return

  silenceEl = new Audio(SILENT_WAV)
  silenceEl.loop = true
  silenceEl.volume = 0.001  // audible only to bats

  navigator.mediaSession.setActionHandler('play',          () => dispatch({ type: 'PLAY_PAUSE' }))
  navigator.mediaSession.setActionHandler('pause',         () => dispatch({ type: 'PLAY_PAUSE' }))
  navigator.mediaSession.setActionHandler('nexttrack',     () => dispatch({ type: 'NEXT' }))
  navigator.mediaSession.setActionHandler('previoustrack', () => dispatch({ type: 'PREV' }))
}

// Call this inside the first user-gesture handler (iOS requires it).
export async function activate() {
  if (silenceEl) {
    try { await silenceEl.play() } catch { /* iOS may still block — user can retry */ }
  }
}

export function setMetadata(title, artist, album = '') {
  if (!('mediaSession' in navigator)) return
  navigator.mediaSession.metadata = new MediaMetadata({ title, artist, album })
  navigator.mediaSession.playbackState = 'playing'
}
